import Footer from "../../components/footer/footer.js";
import Header from "../../components/header/header.js";
import DeepDiveRobotic from "./landingComponents/deepDiveRobotic.js";
import Landing from "./landing/landing.js";
import IntroProduct from "./landingComponents/introProduct.js";
// import LearnMore from "./landingComponents/learnMore.js";
// import KickstarterCountdown from "../../components/KickstarterCountdown/kickstarter-countdown.js";
import IntroCore from "./landingComponents/introCore.js";
import IntroRoboticPhoto from "./landingComponents/introRoboticPhoto.js";
import IntroRoboticMaker from "./landingComponents/introRoboticMakers.js";
import IntroRoboticStudent from "./landingComponents/introRoboticStudent.js";
import IntroRoboticFamily from "./landingComponents/introRoboticFamily.js";
import IntroRoboticGallery from "./landingComponents/introRoboticGallery.js";

export default function Main() {
    return (
    <>
            <div
                className="flex flex-col w-full h-full transition-opacity duration-1000 ease-in-out"
            >
                <Header />
                <section id="landing">
                    <Landing />
                </section>
                <section id="introRoboticPhoto">
                    <IntroRoboticPhoto />
                </section>
                <section id="introRoboticMaker">
                    <IntroRoboticMaker />
                </section>
                <section id="introRoboticStudent">
                    <IntroRoboticStudent />
                </section>
                <section id="main" aria-labelledby="deep-dive-robotics">
                    <DeepDiveRobotic />
                </section>
                <section id="introRoboticFamily">
                    <IntroRoboticFamily />
                </section>
                <section id="introRoboticGallery">
                    <IntroRoboticGallery />
                </section>
                <section id="introCore" aria-labelledby="mission-goal">
                    <IntroCore />
                </section>
                {/* action required: keep the margin between the landing and the about us page */}
                <section id="about" aria-labelledby="design-robotics">
                    <IntroProduct />
                </section>
                <section id="footer" aria-labelledby="kickstarter-kit">
                    <Footer />
                </section>
            </div>
    </>
    )
}
